import StillImage from '../still-image/still-image.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FastAverageColor } from "fast-average-color";

import {
  faRobot
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faRobot
)

const UserAvatar = {
  props: [
    'user',
    'betterShadow',
    'compact',
    'bot'
  ],
  data () {
    return {
      showPlaceholder: false,
      defaultAvatar: `${this.$store.state.instance.server + this.$store.state.instance.defaultAvatar}`,
      earsReady: false,
      earsColor: "white"
    }
  },
  components: {
    StillImage
  },
  methods: {
    imgSrc (src) {
      return (!src || this.showPlaceholder) ? this.defaultAvatar : src
    },
    imageLoadError () {
      this.showPlaceholder = true
    }
  },
  computed: {
    canShowEars () {
      return this.$store.getters.mergedConfig.showCatEars
    }
  },
  mounted () {
    if (this.canShowEars) {
      const fac = new FastAverageColor()
      for (let child of this.$el.children) {
        let img = child.querySelector("img")
        if (img) {
          img.crossOrigin = "anonymous";
          img.onload = () => {
            this.earsColor = fac.getColor(img).hex;
            this.earsReady = true;
          }
        }
      }
    }
  }
}

export default UserAvatar
